import { useState } from "react";

import { Flow } from "src/api/flowTypes";
import { SearchBox } from "src/base-components/SearchBox";
import { FlowCard } from "src/SelectFlowPane/FlowCard";
import { useFuseSearch } from "src/utils/useFuseSearch";

type Props = {
  flows: Flow[];
  onSelect: (flow: Flow) => void;
  excludeFlowIds?: string[];
};

export const FlowList: React.FC<Props> = ({
  flows,
  onSelect,
  excludeFlowIds,
}) => {
  const [filter, setFilter] = useState("");
  const excludeSet = new Set(excludeFlowIds ?? []);
  const search = useFuseSearch(
    flows.filter((flow) => !excludeSet.has(flow.id)),
    { keys: ["name"] },
  );

  return (
    <div className="flex h-full flex-col">
      <div className="mb-2">
        <div className="border-gray-100 border-b pb-2">
          <SearchBox
            dataLoc="search-select-child-flow"
            placeholder="Search a Decision Flow"
            onChange={setFilter}
          />
        </div>
      </div>
      <ul className="decideScrollbar !overflow-y-scroll -mr-4 flex flex-col gap-y-3">
        {search(filter).map((flow) => (
          <FlowCard key={flow.id} flow={flow} onClick={() => onSelect(flow)} />
        ))}
      </ul>
    </div>
  );
};
